import { ArrowRightIcon } from 'lucide-react'

import Timeline, { type TimelineItem } from 'apps/employer_renewals/components/timeline/Timeline'
import useAppNavigation from 'apps/employer_renewals/hooks/useAppNavigation'
import { Button } from 'slab'

type Props = {
  timelineItems: TimelineItem[]
  infoSections: InfoSection[]
  showBackToDashboardButton?: boolean
}

export type InfoSection = {
  title: string
  body: string[]
}

export default function ContentLayout ({ timelineItems, infoSections, showBackToDashboardButton }: Props) {
  const { goToDashboard } = useAppNavigation()

  return (
    <div className='flex flex-row gap-16 flex-wrap'>
      <div className='flex flex-col gap-4 max-w-[20rem]'>
        <div className='body text-gray-500'>
          Expected timeline
        </div>
        <Timeline items={timelineItems} />
      </div>
      <div className='flex flex-col gap-10 flex-1 min-w-40'>
        {infoSections.map((section) => {
          return (
            <div key={section.title} className='flex flex-col gap-4'>
              <div className='body text-gray-500'>
                {section.title}
              </div>
              <div className='flex flex-col gap-4 body-sm'>
                {section.body.map((body) => {
                  return (
                    <p key={body}>
                      {body}
                    </p>
                  )
                })}
              </div>
            </div>
          )
        })}
        {showBackToDashboardButton &&
          <Button
            variant='primary'
            size='large'
            rightIcon={ArrowRightIcon}
            onClick={() => { goToDashboard() }}
          >
            Back to dashboard
          </Button>}
      </div>
    </div>
  )
}
